import { render, staticRenderFns } from "./StandartsCatalogView.vue?vue&type=template&id=4efbf1b0&"
import script from "./StandartsCatalogView.vue?vue&type=script&lang=js&"
export * from "./StandartsCatalogView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports